export default __webpack_public_path__ + "static/media/arrow_right.f423bd7a.svg";